import { useAuthStore } from '@/store/use-auth-store';
import { useUserStore } from '@/store/use-user-store';
import { useNavigation } from './useNavigation';

export const useAuth = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { navigateToLogin } = useNavigation();
  const clearAuth = useAuthStore((state) => state.reset);
  const clearUser = useUserStore((state) => state.clearUser);
  //   const navigate = useNavigate();

  const logout = ({
    redirectToLogin = true,
  }: {
    redirectToLogin?: boolean;
  }) => {
    clearAuth();
    clearUser();
    if (redirectToLogin) {
      navigateToLogin({ replace: true });
    }
  };

  return { isAuthenticated, logout };
};
